// extracted by mini-css-extract-plugin
export default {"whDomainsContainer":"Domains-whDomainsContainer_Lg20J","continue":"Domains-continue_PBkcW","content":"Domains-content_msmue","info":"Domains-info_k7cmj"};